export enum PurchaseTodosDataIndex {
  'todo' = 'todo',
  'retail_products' = 'retail_products',
  'completed' = 'completed',
  'completed_date' = 'completed_date',
  'due_datetime' = 'due_datetime',
}
